
/* eslint-disable camelcase */
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanyClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'CompanyEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  @Prop({ default: false })
  private self !: boolean

  public constructor() {
    super()
    this.client = new CompanyClient()
    this.data = {
      username: '',
      name: '',
      nickName: '',
      address: '',
      phone: '',
      business_license_number: '',
      legal_person: '',
      legal_person_mobile_phone_number: '',
      contact_person: '',
      contact_person_mobile_phone_number: '',
      bank_card_number: '',
      bank_name: '',
      discount: 1
    }
    this.rules = {
      name: [{ required: true, message: '车队名称不能为空', trigger: 'blur' }],
      nickName: [{ required: true, message: '车队简称不能为空', trigger: 'blur' }],
      phone: [{ required: true, message: '车队电话不能为空', trigger: 'blur' }],
      address: [
        { required: true, message: '车队地址不能为空', trigger: 'blur' }
      ],
      username: [
        { required: true, message: '管理员用户名不能为空', trigger: 'blur' }
      ],
      discount: [
        { required: true, message: '折扣不能为空', trigger: 'blur' }
      ]
    }
  }

  public async reset() {
    this.data = {
      username: '',
      name: '',
      nickName: '',
      address: '',
      phone: '',
      business_license_number: '',
      legal_person: '',
      legal_person_mobile_phone_number: '',
      contact_person: '',
      contact_person_mobile_phone_number: '',
      bank_card_number: '',
      bank_name: '',
      discount: 1
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'name',
      'nickName',
      'address',
      'phone',
      'discount',
      'business_license_number',
      'legal_person',
      'legal_person_mobile_phone_number',
      'contact_person',
      'contact_person_mobile_phone_number',
      'bank_card_number',
      'bank_name'
    ])
    data.discount = Number(data.discount)
    return this.clearData(data)
  }

  public async saveData():Promise<Boolean> {
    const self = this
    const form = self.$refs['dataForm'] as any
    return new Promise<Boolean>((resolve, reject) => {
      form.validate(async(valid: any) => {
        if (valid) {
          if (await this.beforeSave()) {
            if (Number(this.id) !== -1) {
              self.listLoading = true
              await self.client.update(
                self.id,
                self.generateData()
              )
              self.listLoading = false
              resolve(true)
            } else {
              const companyClient = self.client as CompanyClient
              await companyClient.createWithUser(self.generateData(), this.data.username)
              resolve(true)
            }
            self.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          }
        } else {
          resolve(false)
        }
      })
    })
  }
}
